export enum AppAccess {
  NO_LICENSE = 'NO_LICENSE',
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  NO_PERMISSION = 'NO_PERMISSION',
  ACCESSIBLE = 'ACCESSIBLE'
}
export type AppAccessKey<R> = {[key in keyof typeof AppAccess]: R };
